// frontend/src/components/JadwalServisForm.js
import React, { useState, useEffect, useContext } from 'react';
import api from '../api/axiosConfig';
import AuthContext from '../context/AuthContext';

const JadwalServisForm = ({ existingData, onSave, onCancel }) => {
  const { user } = useContext(AuthContext);
  const isUserRole = user.role === 'user';
  
  const [kendaraanList, setKendaraanList] = useState([]);
  const [userList, setUserList] = useState([]);

  const [kendaraan, setKendaraan] = useState('');
  const [odometer, setOdometer] = useState('');
  const [tanggal, setTanggal] = useState('');
  const [assignedUser, setAssignedUser] = useState('');
  
  const [loadingKendaraan, setLoadingKendaraan] = useState(true);
  const [loadingUsers, setLoadingUsers] = useState(false);

  useEffect(() => {
    const fetchKendaraan = async () => {
      setLoadingKendaraan(true);
      try {
        const response = await api.get('/api/kendaraan?limit=1000');
        setKendaraanList(response.data.data || []); 
      } catch (error) {
        console.error("Gagal mengambil daftar kendaraan:", error);
        setKendaraanList([]);
      } finally {
          setLoadingKendaraan(false);
      }
    };
    fetchKendaraan();

    if (!isUserRole) {
      const fetchUsers = async () => {
        setLoadingUsers(true);
        try {
          const { data } = await api.get('/api/users/role/user');
          setUserList(data);
        } catch (error) { console.error("Gagal mengambil daftar user:", error); }
        finally { setLoadingUsers(false); }
      };
      fetchUsers();
    }

    if (existingData) {
      setKendaraan(existingData.kendaraan?._id || '');
      setOdometer(existingData.odometer || '');
      setTanggal(existingData.tanggal ? new Date(existingData.tanggal).toISOString().split('T')[0] : '');
      setAssignedUser(existingData.assignedUser?._id || '');
    } else {
      setKendaraan('');
      setOdometer('');
      setTanggal('');
      setAssignedUser('');
    }
  }, [existingData, isUserRole]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!kendaraan) { alert('Harap pilih kendaraan.'); return; }
    if (!isUserRole && !odometer && !tanggal) { alert('Harap isi Odometer atau Tanggal'); return; }
    if (isUserRole && !odometer) { alert('Harap isi Odometer.'); return; }

    const dataToSave = { kendaraan, odometer };
    
    if (!isUserRole || !existingData) {
        dataToSave.tanggal = tanggal || null;
        dataToSave.assignedUser = assignedUser || null;
    }
    
    onSave(dataToSave);
  };

  return (
    <form onSubmit={handleSubmit} className="form-card">
      <div className="form-group">
        <label htmlFor="kendaraan">Nomor Kendaraan</label>
        <select id="kendaraan" value={kendaraan} onChange={(e) => setKendaraan(e.target.value)} required disabled={loadingKendaraan || isUserRole}>
          <option value="">{loadingKendaraan ? 'Memuat...' : '-- Pilih Kendaraan --'}</option>
          {Array.isArray(kendaraanList) && kendaraanList.map(k => (
            <option key={k._id} value={k._id}>
              {k.nomorKendaraan} - {k.jenis}
            </option>
          ))}
        </select>
      </div>
      
      <div className="form-group">
        <label htmlFor="odometer">Odometer (KM)</label>
        <input
          type="number"
          id="odometer"
          value={odometer}
          onChange={(e) => setOdometer(e.target.value)}
          placeholder="Contoh: 20000"
          required={isUserRole}
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="tanggal">Atau Tanggal Servis</label>
        <input
          type="date"
          id="tanggal"
          value={tanggal}
          onChange={(e) => setTanggal(e.target.value)}
          disabled={isUserRole}
        />
      </div>

      {!isUserRole && (
        <div className="form-group">
          <label>Pilih User (Opsional)</label>
          <select value={assignedUser} onChange={(e) => setAssignedUser(e.target.value)} disabled={loadingUsers}>
            <option value="">-- Set up later --</option>
            {userList.map(u => (
              <option key={u._id} value={u._id}>{u.name} ({u.email})</option>
            ))}
          </select>
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
        <button type="button" onClick={onCancel} className="btn-secondary">Batal</button>
        <button type="submit" className="btn-primary">Simpan</button>
      </div>
    </form>
  );
};

export default JadwalServisForm;